/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from "react";
import { PRODUCT_IDS } from "utils/constants";
import { withQuery, BreakpointContext } from "components/common";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ProductCardDefault } from "./ProductCardDefault";
import { CreditMonitoringSnapshot } from "./CreditMonitoringSnapshot";
import { CreditBoostSnapshot } from "./CreditBoostSnapshot";
import { PRODUCT_CARD_DEFAULT_CONFIG } from "./const";
import { HOME_QUERY } from "./gql";

// helper functions to convert user roles to user_products with status
const analyzeRoles = (roles) => {
  const products = [];
  if (roles.user_with_credit_monitoring) {
    products.push({
      productId: PRODUCT_IDS.CREDIT_MONITORING,
      status: roles.user_with_credit_monitoring_enrolled ? "enrolled" : "eligible",
    });
  }
  if (roles.user_with_credit_boost) {
    products.push({
      productId: PRODUCT_IDS.CREDIT_BOOST,
      status: roles.user_with_credit_boost_enrolled ? "enrolled" : "eligible",
    });
  }
  return products;
};

// decide whether to render default card to activated card
const UserProductCard = ({ productId, status, belowBreakpoint }) => {
  const productConfig = PRODUCT_CARD_DEFAULT_CONFIG[productId];
  if (status === "enrolled") {
    switch (productId) {
      case PRODUCT_IDS.CREDIT_MONITORING: return <CreditMonitoringSnapshot belowBreakpoint={belowBreakpoint} redirectUrl={productConfig.redirectUrl} />;
      case PRODUCT_IDS.CREDIT_BOOST: return <CreditBoostSnapshot belowBreakpoint={belowBreakpoint} redirectUrl={productConfig.redirectUrl} />;
      default: return null;
    }
  }
  return <ProductCardDefault belowBreakpoint={belowBreakpoint} { ...productConfig } />;
};

const Home = ({ data, roles }) => {
  const { isBelow } = useContext(BreakpointContext);
  const belowBreakpoint = isBelow("mdl");
  const { first_name: firstName } = data?.simpleUser || {};
  // const userProducts = data.getUserProducts || [];
  const productsToDisplay = analyzeRoles(roles);

  return (
    <div
      className="h-full mx-5 mdl:mx-10"
    >
      <h1 className="text-4xl font-bold">Good afternoon{firstName && <span>, {firstName} 👋</span>}</h1>
      <div className="mt-5 grid grid-cols-1 mdl:grid-cols-2 gap-4">
        {
          productsToDisplay
            .filter((up) => !!PRODUCT_CARD_DEFAULT_CONFIG[up.productId]) // only display listed products
            .map((up) => (<UserProductCard
              productId={up.productId}
              status={up.status}
              belowBreakpoint={belowBreakpoint}
              key={up.productId}
            />))
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  roles: state.user.roles,
});

export default withQuery(HOME_QUERY)(withRouter(connect(mapStateToProps)(Home)));
